import { development } from 'app/config/constants'
import { notice } from 'app/notice'
import { clsx } from 'clsx'
import { Img } from 'component/Image'
import { Space } from 'component/Space'
import { Spinner } from 'component/Spinner'
import { Vertical } from 'component/Vertical'
import { useEffectOnce } from 'hook/useEffectOnce'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { reaction } from 'mobx'
import { observer } from 'mobx-react-lite'
import { ShutterButton } from 'page/ProfileScreen/Selfies/buttons/ShutterButton'
import { opt } from 'store/opt'
import { store } from 'store/store'
import css from './BasicFullCameraPanel.module.scss'

const MOCK_PHOTO = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/fullbody-f1-952d.jpg'

// Фото в полный рост со стенда: овал с камерой и кнопкой затвора внутри.
// Ошибки и кнопки под камерой не показываем — панель состоит только из овала.
export const BasicFullCameraPanel = observer(() => {
  const { camera, userPhoto } = store.profile.common
  const loader = camera.starting || camera.processing
  const failed = !!camera.error
  const src = userPhoto.src

  // Фото не прошло проверку на сервере: сообщаем тостом сверху и возвращаем камеру для нового снимка.
  useEffectOnce(() => {
    userPhoto.clear(true)
    const dispose = reaction(() => userPhoto.err, err => {
      if (!err) return
      notice.error(i18n('PhotoFailedTryAgain'))
      // Фото сброшено вместе с ошибкой — на месте снимка снова появляется видео и камера стартует сама.
      userPhoto.setError(undefined)
    })
    return () => {
      dispose()
      camera.stop()
    }
  })

  const onVideo = useLatestCallback((element: HTMLVideoElement) => {
    camera.element = element
    void camera.start()
  })

  // Локально камеры на стенде нет: клик по овалу имитирует сделанное фото.
  const onMock = useLatestCallback(async () => {
    if (!development || src) return
    camera.stop()
    await userPhoto.setAsset(MOCK_PHOTO, 'fullbody-f1-952d')
  })

  return (
    <Vertical center>
      <Space className={clsx(css.area, failed && css.error)} onClick={development ? onMock : undefined}>
        <Space className={css.inner}>
          {src
            ? <Img className={css.photo} src={src} cover />
            : (
              <video
                key={camera.key}
                ref={onVideo}
                className={clsx(
                  css.video,
                  css[`turn${opt.turn}`],
                  opt.mirror && camera.isFrontCamera && css.mirror,
                )}
              />
            )}
          {loader && (
            <div className={css.loading}>
              <Spinner size={100} />
            </div>
          )}
          {!src && !failed && !loader && <ShutterButton className={css.shutter} photo />}
        </Space>
      </Space>
    </Vertical>
  )
})
